export const DEFAULT_RATE = 31;
